import { Space } from "antd";
import styled from "styled-components";

export const Container = styled(Space)`
	width: calc(100% - 32px);
	max-width: 448px;
	height: 70px;
	padding: 0 16px 0 16px;
	align-items: center;
	text-align: center;
	position: fixed;
	bottom: 0;
	border-radius: 20px 20px 0px 0px;
	background: ${props => props.theme.navbarColor};
	box-shadow: -4px -4px 4px 0px rgba(238, 53, 48, 0.05);
	backdrop-filter: blur(50px);
	z-index: 1000;

	.ant-space-item {
		flex: 0.25;
	}

	#spinwheel {
		max-width: 69px;
	}

	@media screen and (max-width: 399px) {
		gap: 0 !important;
	}

	@media screen and (max-width: 369px) {
		padding: 0 8px 0 8px;
		width: calc(100% - 16px);
		max-width: 464px;

		#spinwheel {
			/* max-width: 60px; */
		}
	}
`;

export const Label = styled.div`
	font-size: 12px;
	font-style: normal;
	letter-spacing: normal;
	line-height: 1.5;
	font-weight: 400;
	text-overflow: ellipsis;
	white-space: nowrap;

	@media screen and (max-width: 365px) {
		font-size: 10px;
	}

	@media screen and (max-width: 330px) {
		font-size: 9px;
	}

	@media screen and (max-width: 298px) {
		font-size: 9px;
	}

	@media screen and (max-width: 272px) {
		font-size: 8px;
	}
`;

export const ItemWrapper = styled.div`
	text-align: center;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 4px 6px;
	gap: 2px;
	border-radius: 16px;
	background: transparent;

	${Label} {
		color: ${(props) => (props.status === "active" ? '#CC0D0E' : "#fff")};
		font-weight: ${(props) => (props.status === "active" ? 700 : 400)};
	}
`;